import $ from 'jquery';

import { $Elements, Classes, Events } from './constants';
import { disableBodyScroll, enableBodyScroll, smoothScrollTo } from './helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	$Elements.PageWrapper.on(Events.click, '.menu-toggle, a[href="#menu-wrapper"], .menu-overlay', function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			$Elements.body.removeClass(Classes.menuOpen);
			enableBodyScroll();
		}
		else {
			$Elements.body.addClass(Classes.menuOpen);
			disableBodyScroll();
		}
	});

	$Elements.PageWrapper.on(Events.click, '.navbar-menu a, .menu-wrapper a', function(e) {

		const linkTarget = this.getAttribute('href');
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			e.preventDefault();

			const section = $(sectionTarget);

			if(section.length) {

				window.history.replaceState(null, null, sectionTarget);

				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll()
				smoothScrollTo(section);
			}
			else if(sectionTarget !== '#') {
				window.location = linkTarget;
			}
		}
	});
});

$Elements.document.on(Events.page.loaded, () => {

	const linkTarget = window.location.href;
	const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

	if(sectionTarget.substring(0, 1) === '#') {

		const section = $(sectionTarget);

		if(section.length) {
			smoothScrollTo(section, 0);
		}
	}

	const parentLinks = document.querySelectorAll('.menu-item-has-children > .menu-link');

	parentLinks.forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			const submenu = this.nextElementSibling;

			document.querySelectorAll('.sub-menu').forEach(el => {
				if (el !== submenu) el.classList.remove('open');
			});
			document.querySelectorAll('.menu-item-has-children > .menu-link').forEach(el => {
				if (el !== this) el.classList.remove('open');
			});

			submenu.classList.toggle('open');
			this.classList.toggle('open');
		});
	});

	document.addEventListener('click', (e)=>{
		const clickInSubmenu = e.target.closest('.menu-item-has-children');

		if(!clickInSubmenu){
			document.querySelectorAll('.sub-menu.open').forEach(el => el.classList.remove('open'));
			document.querySelectorAll('.menu-item-has-children > .menu-link.open').forEach(el => el.classList.remove('open'));
		}
	})
});
